"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _KnockItemFooter = require("./KnockItemFooter");
Object.keys(_KnockItemFooter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _KnockItemFooter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _KnockItemFooter[key];
    }
  });
});